<div>
  <app-table-component
    [cols]="cols"
    [data]="archivedCounterData()"
    [totalRecords]="sessionServiceRespone()?.totalElements"
    [loading]="tableLoading()"
    [searchable]="true"
    searchInputPlaceholder="Search Counter"
    (onChangePage)="onChangePage($event)"
    (searchFilter)="onSearchCounterFilter($event)"
  >
    <div tableCaptionBottomContainer>
      <div>
        <div class="my-3">
          <p-floatlabel variant="on" class="!inline-block">
            <app-date-picker-component
              (onChangeEvent)="onChangeDateRangeFilter($event)"
              (onCancelEvent)="cancelDateRange($event)"
            ></app-date-picker-component>
            <label for="archived_date_range" class="ml-10">Archived Date Range</label>
          </p-floatlabel>

          <p-select
            [(ngModel)]="selectedAppType"
            [options]="appTypeList"
            optionLabel="label"
            optionValue="value"
            [showClear]="true"
            class="mx-3"
            placeholder="Select App Type"
            (ngModelChange)="onChangeFilter()"
          />
          <p-autocomplete
            [(ngModel)]="selectedUser"
            [suggestions]="userList()"
            optionLabel="username"
            optionValue="username"
            [minLength]="2"
            placeholder="Search and Select User"
            (completeMethod)="onSearchUser($event)"
            (onSelect)="onChangeFilter()"
            (onClear)="onChangeFilter()"
          />
        </div>
      </div>
    </div>
  </app-table-component>

  <!-- Templates -->
  <ng-template #nameColumnTemplate let-rowData="rowData">
    <span class="font-bold">{{ rowData.computerName }}</span>
    <span class="pl-2" *ngIf="rowData.isActivityStarter">
      <i
        class="pi pi-question-circle !text-sm"
        pTooltip="No activity has been detected for the past {{
          rowData.daysSinceLastActivity
        }} days."
      ></i>
    </span>
  </ng-template>

  <ng-template #appTypeColumnTemplate let-rowData="rowData">
    @switch (rowData?.serverPingInformation?.Url) {
      @case ('acente.flypgs.com') {
        <span>DCS</span>
      }
      @case ('pax.flypgs.com') {
        <span>DCS</span>
      }
      @case ('paxcontrol.flypgs.com') {
        <span>PAXCONTROL</span>
      }
      @case ('prep.flypgs.com') {
        <span>TEST</span>
      }
      @case ('pctest.flypgs.com') {
        <span>TEST</span>
      }
      @case ('dracente.flypgs.com') {
        <span>DR DCS</span>
      }
      @case ('drpax.flypgs.com') {
        <span>DR DCS</span>
      }
      @case ('fallback.flypgs.com') {
        <span>FALLBACK</span>
      }
      @default {
        <span>{{ rowData?.applicationType || '-' }}</span>
      }
    }
  </ng-template>

  <ng-template #sessionStartDateColumnTemplate let-rowData="rowData">
    <span>{{ rowData.loginTime | date: 'dd.MM.yyyy | HH:mm' }}</span>
  </ng-template>

  <ng-template #archivedDateColumnTemplate let-rowData="rowData">
    <span>{{ rowData.logoutTime | date: 'dd.MM.yyyy | HH:mm' }}</span>
  </ng-template>

  <ng-template #statusColumnTemplate let-rowData="rowData">
    <div
      [class]="
        rowData.serverPingInformation?.Status === 'OFFLINE'
          ? 'status-indicator error'
          : 'status-indicator'
      "
    >
      <div
        [class]="
          rowData.serverPingInformation?.Status === 'OFFLINE' ? 'status-dot error' : 'status-dot'
        "
      ></div>
    </div>
  </ng-template>

  <ng-template #detailColumnTemplate let-rowData="rowData">
    <p-button outlined variant="text" severity="info" (onClick)="openDetailDialog(rowData)">
      Show Detail
    </p-button>
  </ng-template>

  <app-counter-detail />
</div>
